import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { hasFeature } from 'client/modules/Auth/AuthReducer';
import UpgradeCTA from './UpgradeCTA';

function FeatureGate({ feature, children, fallback }) {
  const allowed = useSelector(state => hasFeature(state, feature));

  if (allowed) {
    return children;
  }

  if (fallback !== undefined) {
    return fallback;
  }

  return <UpgradeCTA feature={feature} />;
}

FeatureGate.propTypes = {
  feature: PropTypes.string.isRequired,
  children: PropTypes.node,
  fallback: PropTypes.node,
};

FeatureGate.defaultProps = {
  children: null,
  fallback: undefined,
};

export default FeatureGate;
